import { Auth } from 'aws-amplify';
import { fetchForgotPasswordGraphQL } from './graphql/forgotPasswordGraphQL';

export const fetchRegister = async ({
  firstName, lastName, email, password,
}) => {
  const response = await Auth.signUp({
    username: email,
    password,
    attributes: {
      email,
      given_name: firstName,
      family_name: lastName
    }
  });

  return response.userSub;
};

export const fetchRegisterCodeResend = async ({ email }) => {
  await Auth.resendSignUp(email);
};

export const fetchLogin = async ({ email, password }) => {
  return Auth.signIn(email, password);
};

export const fetchCompleteNewPassword = async ({ cognitoUser, newPassword }) => {
  return Auth.completeNewPassword(cognitoUser, newPassword);
};

export const fetchForgotPassword = async ({ email }) => {
  // Use GraphQL API which handles non-existent users gracefully
  return fetchForgotPasswordGraphQL({ email });
};

export const fetchForgotPasswordSubmit = async ({ username, password, code }) => {
  return Auth.forgotPasswordSubmit(username, `${code}`, password);
};

export const fetchCurrentCognitoUser = async () => {
  return Auth.currentAuthenticatedUser();
};

export const fetchLogout = async () => {
  await Auth.signOut();
};

export const fetchUpdateUser = async ({ attributes }) => {
  const user = await fetchCurrentCognitoUser();

  await Auth.updateUserAttributes(user, attributes);
};

export const fetchChangePassword = async ({ oldPassword, newPassword }) => {
  const cognitoUser = await fetchCurrentCognitoUser();

  await Auth.changePassword(cognitoUser, oldPassword, newPassword);
};
